import { useGet, usePut } from '../../../../sharedModules/hooks/useQuery';
import { StatementConfig } from '../model';

export function useStatementConfig(location: string, enabled = true) {
  return useGet<StatementConfig>({
    url: `/collections/statement_configs/${location}`,
    enabled: !!location && enabled,
  });
}

export function useUpdateStatementConfig() {
  return usePut<StatementConfig>();
}
